<ng-container *ngIf="path">
  <div class="d-flex justify-content-between khr-page-title align-items-center  ps-3 pe-2 py-1 border-bottom" draggable="false">
    <span class="invoiceSource w-100"
      container="body"
      *ngIf="name"
      [pmdTooltip]="name"
      draggable="false">
      {{name}}
    </span>
    <div class="text-end position-relative m-1"
      [ngClass]="{'invoice-review-btn-wrap-zoom': name, 'btn-wrap-zoom': !name}"
      draggable="false">

      <button class="me-1 d-none d-xl-flex"
        *ngIf="showFullScreenBtn"
        type="button"
        (click)="toggleFullScreen()"
        color="dark"
        pmdRipple
        pmd-btn
        size="xs"
        draggable="false">
        <i class="material-icons" draggable="false">
          {{ isFullScreen ? 'close_fullscreen' : 'open_in_full' }}
        </i>
      </button>
      <button id="zoom-out"
        class="me-1"
        type="button"
        color="dark"
        pmdRipple
        pmd-btn
        size="xs"
        (click)="zoomOut()"
        draggable="false">
        <i class="material-icons" draggable="false">remove</i>
      </button>
      <button class="me-1"
        id="zoom-in"
        type="button"
        pmd-btn
        pmdRipple
        color="dark"
        pmdRipple
        size="xs"
        (click)="zoomIn()"
        draggable="false">
        <i class="material-icons" draggable="false">add</i>
      </button>
      <button class="me-1"
        pmd-btn
        pmdRipple
        color="dark"
        pmdRipple
        size="xs"
        (click)="rotate()"
        draggable="false">
        <i class="material-icons" draggable="false">rotate_right</i>
      </button>
      <button class="me-1"
        pmd-btn
        pmdRipple
        color="dark"
        pmdRipple
        size="xs"
        (click)="antiRotate()"
        draggable="false">
        <i class="material-icons" draggable="false">rotate_left</i>
      </button>
      <button class="me-1"
        *ngIf="downlaodVisible"
        type="button"
        (click)="downloadFilesAsZip()"
        pmd-btn
        color="dark"
        pmdRipple
        class="bg-dark border-dark"
        size="xs"
        draggable="false">
        <i class="material-icons text-white" draggable="false">download</i>
      </button>
      <button *ngIf="showCloseIcon"
        pmd-btn
        color="dark"
        pmdRipple
        size="xs"
        aria-label="Close"
        (click)="onClose()"
        draggable="false">
        <i class="material-icons" draggable="false">close</i>
      </button>
    </div>
  </div>
  <div class="pdf-image-container bg-light"
    (mousedown)="startDrag($event)"
    (mouseleave)="leave()">
    <small *ngIf="isDuplicate"
      class="on-badge status-duplicate duplicate-indicator pmd-badge badge rounded-pill border bg-white">
      Duplicate
    </small>
    <pdf-viewer [src]="path"
      [render-text]="true"
      [original-size]="true"
      [fit-to-page]="true"
      [external-link-target]="'blank'"
      [autoresize]="true"
      [zoom-scale]="zoomScale"
      [rotation]="rotation"
      [zoom]="zoom"
      [show-all]="!page && page !== 0"
      [page]="page"
      [style.--drag-x.px]="posX"
      [style.--drag-y.px]="posY"
      class="w-100 pdf_viewer_block"
      (after-load-complete)="onPdfLoaded()">
    </pdf-viewer>
  </div>
</ng-container>